<template>
    <div :class="styleMain">
      <status-period-stopwatch :start="dateStart" :end="dateEnd" :statusId="statusId" @update="update"/>
    </div>
</template>

<script>
import StatusPeriodStopwatch from '../status/StatusPeriodStopwatch'

export default {
  name: 'SportFootballMatchActionStopwatch',
  components: { StatusPeriodStopwatch },
  props: {
    action: Object
  },
  computed: {
    dateStart () { return new Date(this.action.match.dateStartByStatus(this.action.statusId) - this.action.match.offset(this.action)) },
    dateEnd () { return this.action.date },
    statusId () { return this.action.statusId },

    styleMain () { return ['sportFootballMatchActionStopwatch', this.action.homeAway] }
  },
  methods: {
    update (value) {
      const date = new Date(this.dateStart.getTime() - value.getTime() + this.dateEnd.getTime())
      this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, date: date })
    }
  }
}
</script>

<style>
.sportFootballMatchActionStopwatch {
  grid-area: second;
  z-index:1;
}
.sportFootballMatchActionStopwatch .el-popover__reference{
  height:22px;
  font-size:10px;
  border-radius:16px;
  padding:0 10px;
  text-align: center;
  background-color:white;
  color:black;
  border-color: var(--color-border-grey);
  border-style:solid;
  border-width:1px;
}
.sportFootballMatchActionStopwatch .el-popover__reference:hover{
  cursor:pointer;
}
</style>
